var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"t-popup"},[_c('transition',{attrs:{"name":"popup-fade","appear":""}},[(_vm.show)?_c('div',{staticClass:"t-popup-wrapper"}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }